<template>
  <div class="token-login-page" v-loading="loading" element-loading-text="正在登录…">
    <div class="token-login-inner" />
  </div>
</template>

<script>
import { mapMutations } from "vuex";

/**
 * 通过 query.t 换票登录：POST /passport/token_login { token: t }
 * 会话写入顺序与 SlideLogin 账号登录成功分支保持一致。
 */
export default {
  name: "tLogin",
  data() {
    return {
      loading: true,
      ran: false,
    };
  },
  methods: {
    ...mapMutations(["handleUserInfo"]),
    initRespErrMsgBoxMark() {
      this.$store.commit("changeRespErrMsgBoxMark", false);
    },
    pickQueryToken() {
      const raw = this.$route.query.t;
      if (raw == null || raw === "") return "";
      return Array.isArray(raw) ? String(raw[0] || "").trim() : String(raw).trim();
    },
    pickErrorMessage(err) {
      const d = err && err.data;
      if (d && (d.message || d.msg)) return d.message || d.msg;
      if (typeof err === "string") return err;
      return "登录失败，请重新进入";
    },
    /**
     * 与 SlideLogin.accountLogin 成功分支一致（mxInitSwitch → 存储 → getUserProfile → 提示 → 进首页 → 弱密码）
     */
    async persistSessionLikePasswordLogin(userInfo) {
      this.mxInitSwitch();
      this.handleUserInfo(userInfo);
      this.$storage.set("nowCompany", { id: userInfo.company_id });
      this.$storage.set("settlementId", userInfo.settlement_id);

      const userInfos = await this.$api.getUserProfile();
      const roles = userInfo.roles || [];
      this.$storage.set("is_yichen", roles.includes("yichendaodi"));
      this.$storage.set("roles", roles);
      this.$storage.set("user_info", userInfos);

      this.$message.success("登录成功");
      this.mxRedirect("/home");

      const weak = userInfo.weak_password_info;
      if (weak && weak.weak_password) {
        this.$alert(weak.message, "提醒", {
          confirmButtonText: "确定",
          callback: () => {},
        });
      }
    },
    failToLoginIndex(msg) {
      this.initRespErrMsgBoxMark();
      if (msg) this.$message.error(msg);
      this.mxRedirect("/login");
    },
    async execute() {
      const token = this.pickQueryToken();
      if (!token) {
        this.loading = false;
        this.failToLoginIndex("缺少登录参数");
        return;
      }
      try {
        const userInfo = await this.$api.tokenLogin({ token });
        if (!userInfo) {
          this.loading = false;
          this.failToLoginIndex("登录失败");
          return;
        }
        await this.persistSessionLikePasswordLogin(userInfo);
      } catch (e) {
        console.error("[token_login]", e);
        this.failToLoginIndex(this.pickErrorMessage(e));
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.ran) return;
    this.ran = true;
    this.initRespErrMsgBoxMark();
    this.execute();
  },
};
</script>

<style lang="stylus" scoped>
.token-login-page
  min-height 200px
  position relative
.token-login-inner
  min-height 120px
</style>
